import React, { useContext } from "react";
import { IntlContext } from "context";
import { BookingContext } from "app/OurService/Booking/Context";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

const GardeningFields: React.FC = () => {
    const intl = useContext(IntlContext);
    const booking = useContext(BookingContext);
    const bringTools = booking.getService()?.data.bring_tools;

    return (
        <div className="grid--2 grid--small-1 grid--has-gutter-5x margin-top--4">
            <div className="service_detail">
                <Icon icon={{ prefix: "fas", iconName: "seedling" }} />
                <span className="margin-left--1">
                {bringTools
                    ? intl.formatMessage("our_services.label.bring_yes")
                    : intl.formatMessage("our_services.label.bring_no")}
                </span>
            </div>
        </div>
    );
};

export default GardeningFields;
